import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../transactional/auth/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        authService.logout();
        window.location.href = '/auth/login';
      }

      if (error.status === 0) {
        console.error('Network error');
      }

      if (error.status >= 500) {
        console.error('Server error');
      }

      return throwError(() => error);
    }),
  );
};
